// calculates days based on num of months provided
export default function calculateDaysInMonths(
  numOfMonths = 0,
  date = new Date(),
) {
  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

  const endDate = new Date(date);
  // increase end date by provided number of months
  endDate.setMonth(endDate.getMonth() + numOfMonths);

  // calculate difference between dates and round down to nearest integer
  return Math.floor(Math.abs((endDate.getTime() - date.getTime()) / oneDay));
}
